import * as React from "react";
const SideDropArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9.407 6.536 4.693 11.25l1.179 1.179 4.125-4.125 4.125 4.125L15.3 11.25l-4.714-4.714a.833.833 0 0 0-1.179 0Z"
        clipRule="evenodd"
      />
    </g>
    <rect
      width={18}
      height={18}
      x={1}
      y={1}
      stroke="#fff"
      strokeWidth={2}
      rx={5}
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M20 15V5H0v10z" />
      </clipPath>
    </defs>
  </svg>
);
export default SideDropArrow;
